import { css } from '@emotion/react'
import { gemVar, Spacing, ThemedColors, Typography } from '@opallabs/gem'

const rootClass = 'opal-calendar-page-header'
export const selectors = {
  root: rootClass,
  title: `${rootClass}-title`,
} as const

/**
 * Three tracks, so the timescale control sits in the middle of the row rather
 * than in the middle of what the title leaves over. When the row is too narrow
 * for that, the title gives way: the actions keep the width they need, and the
 * timescales move off the middle rather than under them.
 *
 * The design hangs the 36px row off the top of the 52px band: 16px above it
 * and nothing below, so the title sits level with the control bar under it.
 */
export const root = css({
  alignItems: 'center',
  backgroundColor: gemVar(ThemedColors.Surface1),
  blockSize: Spacing.XS * 13,
  boxSizing: 'border-box',
  display: 'grid',
  flex: 'none',
  gap: Spacing.S,
  gridTemplateColumns: '1fr auto 1fr',
  paddingBlockEnd: 0,
  paddingBlockStart: Spacing.M,
  paddingInline: Spacing.M,
})

export const start = css({
  alignItems: 'center',
  display: 'flex',
  gap: Spacing.S,
  minInlineSize: 0,
})

export const title = css({
  // The size Plans gives a page title, so the two pages read as one product.
  ...Typography.H500,
  color: gemVar(ThemedColors.TextPrimary),
  margin: 0,
  minInlineSize: 0,
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
})

export const center = css({
  alignItems: 'center',
  display: 'flex',
  justifyContent: 'center',
})

export const end = css({
  alignItems: 'center',
  display: 'flex',
  gap: Spacing.S,
  justifyContent: 'flex-end',
})
